import lazyWithRetry from '@shared/lib/lazyWithRetry';

import Loadable from '@components/Loadable/Loadable';
import { SuperAdminProtectedRoute } from '@providers/SuperAdminProtectedRoute/ui/SuperAdminProtectedRoute';

const MultiDocumentAgentDemandLetterCreatePage = Loadable(
  lazyWithRetry(
    () =>
      import(
        '@pages/SuperAdminPanelPage/MultiDocumentAgentPage/demand-letter/create'
      )
  )
);
const MultiDocumentAgentDemandLetterUpdatePage = Loadable(
  lazyWithRetry(
    () =>
      import(
        '@pages/SuperAdminPanelPage/MultiDocumentAgentPage/demand-letter/update'
      )
  )
);
const MultiDocumentAgentDepositionSummaryCreatePage = Loadable(
  lazyWithRetry(
    () =>
      import(
        '@pages/SuperAdminPanelPage/MultiDocumentAgentPage/deposition-summary/create'
      )
  )
);
const MultiDocumentAgentDepositionSummaryUpdatePage = Loadable(
  lazyWithRetry(
    () =>
      import(
        '@pages/SuperAdminPanelPage/MultiDocumentAgentPage/deposition-summary/update'
      )
  )
);

const MultiDocumentAgentCustomGptEditorPage = Loadable(
  lazyWithRetry(
    () => import('@pages/SuperAdminPanelPage/MultiDocumentAgentPage/custom-gpt')
  )
);

const MultiDocumentAgentUseCaseCreatePage = Loadable(
  lazyWithRetry(
    () =>
      import(
        '@pages/SuperAdminPanelPage/MultiDocumentAgentPage/use-case/create'
      )
  )
);
const MultiDocumentAgentUseCaseUpdatePage = Loadable(
  lazyWithRetry(
    () =>
      import(
        '@pages/SuperAdminPanelPage/MultiDocumentAgentPage/use-case/update'
      )
  )
);

const MultiDocumentAgentRoutes = {
  path: 'admin/multi-document-agent',
  element: <SuperAdminProtectedRoute />,
  children: [
    {
      path: 'demand-letter/create',
      element: <MultiDocumentAgentDemandLetterCreatePage />,
    },
    {
      path: 'demand-letter/edit/:id',
      element: <MultiDocumentAgentDemandLetterUpdatePage />,
    },
    {
      path: 'deposition-summary/create',
      element: <MultiDocumentAgentDepositionSummaryCreatePage />,
    },
    {
      path: 'deposition-summary/edit/:id',
      element: <MultiDocumentAgentDepositionSummaryUpdatePage />,
    },
    {
      path: 'custom-gpt/editor',
      element: <MultiDocumentAgentCustomGptEditorPage />,
    },
    {
      path: 'custom-gpt/editor/:id',
      element: <MultiDocumentAgentCustomGptEditorPage />,
    },
    {
      path: 'use-case/create',
      element: <MultiDocumentAgentUseCaseCreatePage />,
    },
    {
      path: 'use-case/edit/:id',
      element: <MultiDocumentAgentUseCaseUpdatePage />,
    },
  ],
};

export default MultiDocumentAgentRoutes;
